export default {"src":"/_next/static/media/vision.ed633add.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};